import { ButtonItemAccount, Layout } from "../../../components";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getMyProfile } from "../../../service/usersService";
import { FiCopy, FiDownload } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../../redux/utlsSlice";
import { RootState } from "../../../redux/store";
import { checkImageExists } from "../../../utls/img";
import { MINIO } from "../../../data/data";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { callAPIWhiteToken } from "../../../config/api";
import Swal from "sweetalert2";
const BASE_URL = process.env.REACT_APP_BASEURL;

const Account = () => {
  const navigate = useNavigate();

  const { users } = useSelector((state: RootState) => state.reducer.utlsSlice);
  const [imagePreview, setImagePreview] = useState("");
  const [imageExists, setImageExists] = useState(false);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false); // State untuk loading
  const dispatch = useDispatch<any>();

  const getMyDataProfile = async () => {
    const response = await getMyProfile();
    if (!response?.error) {
      dispatch(setUser(response?.data));
      loadImage(response?.data.thumbnail);
    }
  };

  useEffect(() => {
    getMyDataProfile();
  }, []);

  const signOut = () => {
    Cookies.remove("token");
    navigate("/auth");
  };

  const deleteaccount = () => {
    Cookies.remove("token");
    navigate("/auth");
  };

  const handleDeleteAccount = async () => {
    const result = await Swal.fire({
      title: "Apakah Anda yakin?",
      text: "Akun Anda akan dihapus secara permanen dan tindakan ini tidak dapat dibatalkan!",
      icon: "warning",
      showCancelButton: true,
      // Kita tidak akan menggunakan properti warna di sini lagi
      // confirmButtonColor: '#d33',
      // cancelButtonColor: '#3085d6',
      confirmButtonText: "Ya, hapus akun!",
      cancelButtonText: "Batal",
      // --- TAMBAHKAN INI ---
      // Menambahkan class custom ke tombol
      customClass: {
        confirmButton: "btn-sweetalert-confirm", // Class untuk tombol konfirmasi
        cancelButton: "btn-sweetalert-cancel", // Class untuk tombol batal
      },
    });

    if (result.isConfirmed) {
      // ... sisa logika Anda sudah benar ...
      setIsDeleting(true);
      try {
        const response = await callAPIWhiteToken({
          url: "/users/delete-account",
          method: "POST",
        });

        if (!response) {
          setIsDeleting(false);
          return;
        }

        if (!response.error) {
          await Swal.fire(
            "Dihapus!",
            "Akun Anda telah berhasil dihapus.",
            "success"
          );
          Cookies.remove("token");
          navigate("/auth");
        } else {
          toast.error(response.message || "Gagal menghapus akun.");
        }
      } catch (error) {
        console.error("Delete account error:", error);
        toast.error("Terjadi kesalahan yang tidak terduga.");
      } finally {
        setIsDeleting(false);
      }
    }
  };

  const loadImage = async (thumbnail: string) => {
    const imageUrl = `${MINIO}/${thumbnail}`;
    const exists = await checkImageExists(imageUrl);
    setImageExists(exists);
    setImagePreview(exists ? imageUrl : "/assets/imgs/no-user-image-icon.jpg");
  };

  const openNewWindow = () => {
    const url = "/admin/account/id-card"; // URL tujuan
    const windowName = "Print"; // Nama jendela baru
    const windowFeatures = "width=800,height=600,location=no"; // Fitur jendela baru

    const newWindow = window.open(url, windowName, windowFeatures);
  };

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(`${BASE_URL}/register/${users?.reffCode}`)
      .then(() => {
        setIsTooltipVisible(true);
      });

    setTimeout(() => {
      setIsTooltipVisible(false);
    }, 1000);
  };

  return (
    <Layout showNavBar={false} showNavigation={true}>
      <div className="mt-5 mb-[7rem] min-h-screen overflow-auto">
        <div className="flex gap-5 bg-white shadow-md rounded-lg mb-2 border-b px-4 py-8">
          <div className="box-rd-img">
            <button
              onClick={() => {
                navigate("/admin/account/change-profile-picture");
              }}
              className="upload-btn"
            >
              <img src={imagePreview} alt="" className="w-20 h-20" />
              <span className="upload-text">Edit</span>
            </button>
          </div>
          <div>
            <span className="member-name-profile">{users.fullName}</span>
            <span className="text-sky-500 text-[12px] block ">
              {users.memberType?.name || ""}
            </span>
            <span className="text-gray-800 font-bold text-[12px] block mt-5">
              ID {users.code}
            </span>
          </div>
        </div>
        {users?.reffCode && (
          <div className="bg-white rounded-lg border-b shadow-md mb-5 p-4 w-full flex items-center justify-between text-gray-800 font-bold">
            <p>
              Refferal Link: <br /> {`${BASE_URL}/register/${users?.reffCode}`}
            </p>
            <div className='relative flex flex-col items-center justify-center p-4"'>
              <button
                onClick={copyToClipboard}
                className="text-white text-[14px] bg-blue-500 p-2.5 rounded"
              >
                <FiCopy />
              </button>

              {isTooltipVisible && users?.reffCode && (
                <div className="absolute bottom-full mb-2 px-2 py-1 text-xs font-normal text-white bg-gray-800 rounded-lg">
                  copied!
                </div>
              )}
            </div>
          </div>
        )}
        <div className="flex items-center justify-center">
          <button
            onClick={() => {
              openNewWindow();
            }}
            className="btn bg-yellow-400 flex gap-3 items-center"
          >
            <span className="font-bold">Download ID Card</span>
            <i className="rounded-full bg-blue-500 p-1 text-white">
              <FiDownload />
            </i>
          </button>
        </div>
        <ButtonItemAccount
          onClick={() => {
            navigate("/admin/account/edit-profile");
          }}
          title={"Edit Profile"}
          src={"/assets/imgs/icon-profile.png"}
        />
        {/* <ButtonItemAccount
                    title={'Alamat Saya'}
                    src={'/assets/imgs/icon-addres.png'}
                /> */}
        <ButtonItemAccount
          onClick={() => {
            navigate(`/admin/account/chart/${users.uniqueId}`);
          }}
          title={"Kemitraan"}
          src={"/assets/imgs/icon-mitra.png"}
        />
        <ButtonItemAccount
          onClick={() => {
            navigate("/admin/account/sosial-media");
          }}
          title={"Social Media & Market Place"}
          src={"/assets/imgs/icon-sosial.png"}
        />
        <ButtonItemAccount
          onClick={() => {
            navigate("/admin/account/offline-store");
          }}
          title={"Toko Offline"}
          src={"/assets/imgs/icon-sosial.png"}
        />
        <ButtonItemAccount
          title={"Notifikasi Setting"}
          src={"/assets/imgs/icon-notif.png"}
        />
        <ButtonItemAccount
          onClick={() => {
            navigate("/admin/account/privacy-policy");
          }}
          title={"Security & Privacy"}
          src={"/assets/imgs/icon-security.png"}
        />
        <ButtonItemAccount
          onClick={() => {
            navigate("/admin/account/help-center");
          }}
          title={"Pusat Bantuan"}
          src={"/assets/imgs/icon-phone.png"}
        />
        <ButtonItemAccount
          title={"Delete Account"}
          src={"/assets/imgs/delete-2.svg"}
          onClick={() => handleDeleteAccount()}
        />
        <ButtonItemAccount
          title={"Log Out"}
          src={"/assets/imgs/icon-close.png"}
          onClick={() => signOut()}
        />
      </div>
    </Layout>
  );
};

export default Account;
